import {
  Home,
  User,
  ChevronLeft,
  ChevronRight,
  ListPlus,
  Search,
  Settings,
  X,
  Check,
  Info,
  Calendar,
  Download,
  Paperclip,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Brain,
  Briefcase,
  CircleAlert,
  CircleCheck,
  CircleHelp,
  CircleMinus,
  CirclePlus,
  CircleX,
  Edit,
  Funnel,
  Heart,
  LeafyGreen,
  Lightbulb,
  Music,
  PencilRuler,
  Trash2,
  Users,
  FileText,
  SlidersHorizontal,
  Loader,
} from 'lucide-react';

const ICONS = {
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  brain: Brain,
  briefcase: Briefcase,
  calendar: Calendar,
  check: Check,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-help': CircleHelp,
  'circle-minus': CircleMinus,
  'circle-plus': CirclePlus,
  'circle-x': CircleX,
  download: Download,
  edit: Edit,
  'file-text': FileText,
  funnel: Funnel,
  heart: Heart,
  home: Home,
  info: Info,
  'leafy-green': LeafyGreen,
  lightbulb: Lightbulb,
  'list-plus': ListPlus,
  loader: Loader,
  music: Music,
  paperclip: Paperclip,
  'pencil-ruler': PencilRuler,
  search: Search,
  settings: Settings,
  'sliders-horizontal': SlidersHorizontal,
  'trash-2': Trash2,
  user: User,
  users: Users,
  x: X,
} as const;

type IconName = keyof typeof ICONS;

const getIconNames = () => {
  return Object.keys(ICONS) as IconName[];
};

const getIconComponent = (name: IconName) => {
  return ICONS[name];
};

export { getIconComponent, getIconNames, ICONS };
export type { IconName };
